import { Colors } from 'constants/ui';
import { ProfileHeader } from 'pages/Profile/scene/ui/header';
import { ReputationBreakdown } from 'pages/Profile/scene/ui/reputation';
import { ReviewsList } from 'pages/Profile/scene/ui/reviews';
import { ServicesList } from 'pages/Profile/scene/ui/services';
import * as profileStyled from 'pages/Profile/scene/styles';

import { PersonaId } from '../../personas';
import * as fakePhone from '../styles/fake-phone';
import * as styled from '../styles/fake-phone-reviews';
import { synthesizeProfile } from '../synthesize-profile';

type Props = {
  personaId: PersonaId;
};

const STATUS_TIME = '9:41';
const STATUS_RIGHT = '5G ●●●';

const NOOP = () => undefined;

export const FakePhoneReviews = ({ personaId }: Props) => {
  const data = synthesizeProfile(personaId);
  const accentColor = data.provider.accent_color ?? Colors.accent;

  return (
    <styled.FrameWrap>
      <fakePhone.StatusBar>
        <span>{STATUS_TIME}</span>
        <fakePhone.StatusIcons>{STATUS_RIGHT}</fakePhone.StatusIcons>
      </fakePhone.StatusBar>
      <styled.ScrollableArea>
        <styled.ZoomedViewport>
          <profileStyled.TopBar>
            <profileStyled.TopBarInner>
              <profileStyled.Logo as="div">
                <profileStyled.LogoMark>K</profileStyled.LogoMark>
                <profileStyled.LogoWordmark>kudable</profileStyled.LogoWordmark>
              </profileStyled.Logo>
              <profileStyled.PromoCta as="div">
                ✨ Get your own profile
              </profileStyled.PromoCta>
            </profileStyled.TopBarInner>
          </profileStyled.TopBar>
          <profileStyled.Container>
            <profileStyled.Card>
              <ProfileHeader
                provider={data.provider}
                reputation={data.reputation}
                responseTimeHours={data.responseTimeHours}
                intents={data.intents}
                subscriptionActive={data.subscriptionActive}
                onPickIntent={NOOP}
                onOpenChooser={NOOP}
              />
            </profileStyled.Card>

            {data.services.length > 0 && (
              <profileStyled.Card>
                <profileStyled.SectionHeader>
                  <profileStyled.SectionTitle>Services</profileStyled.SectionTitle>
                </profileStyled.SectionHeader>
                <ServicesList
                  services={data.services}
                  currency={data.provider.currency}
                  accentColor={accentColor}
                />
              </profileStyled.Card>
            )}

            {data.reputation.category_averages.length > 0 && (
              <profileStyled.Card>
                <profileStyled.SectionTitle>
                  Reputation Breakdown
                </profileStyled.SectionTitle>
                <ReputationBreakdown
                  categoryAverages={data.reputation.category_averages}
                />
              </profileStyled.Card>
            )}

            <profileStyled.Card>
              <profileStyled.SectionTitle>
                Reviews ({data.reputation.review_count})
              </profileStyled.SectionTitle>
              <ReviewsList
                reviews={data.reviews}
                hasMore={false}
                isLoading={false}
                onLoadMore={NOOP}
                sort="recent"
                badge="all"
                search=""
                accentColor={accentColor}
                onSortChange={NOOP}
                onBadgeChange={NOOP}
                onSearchChange={NOOP}
              />
            </profileStyled.Card>
          </profileStyled.Container>
        </styled.ZoomedViewport>
      </styled.ScrollableArea>
    </styled.FrameWrap>
  );
};
